import React from 'react';
import styles from '../../../assets/css/styling.module.css';
import styles3 from '../../../assets/css/newStyling.module.css';
import { TransitionGroup } from 'react-transition-group';
import ResizeDetector from "react-resize-detector";
import LoadingOverlay from 'react-loading-overlay-ts';
import Loader from "react-loaders";
import { useState, useEffect } from 'react';
import referImage from '../../../assets/images/refer_image.png'
import bronze_badge from '../../../assets/images/bronze.png'
import silver_badge from '../../../assets/images/silver.png'
import gold_badge from '../../../assets/images/gold.png'
import pointsBadge from '../../../assets/images/medal.png'
import tick_icon from '../../../assets/images/correct.png'
import streak from '../../../assets/images/streak.png'
import { Line, Circle } from 'rc-progress';
import SecureLS from 'secure-ls';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert'
import { getUserDetails } from '../../../actions/user_action';
import { respondentDashboardDetails } from '../../../actions/dashboard_activities';
import check_mark from '../../../assets/images/check-mark.png'


function ConnectPoints() {
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const [profileCompletion, setProfileCompletion] = useState(0)
    const [points, setPoints] = useState(0)
    const [percentToNextThreshold, set_percentToNextThreshold] = useState({})
    const [referCode, setReferCode] = useState('')
    const [copied, setCopied] = useState(false);
    const ls = new SecureLS()
    const userId = ls.get('accessUser').user._id

    useEffect(() => {


        // getting user and dashboard details
        dispatch(getUserDetails(userId))
            .then(response => {

                setReferCode(response.payload.content.referralCode)

                dispatch(respondentDashboardDetails())
                    .then(response2 => {

                        setProfileCompletion(response2.payload.content.profileCompletion)
                        //setProfileCompletion(100)
                        setPoints(response2.payload.content.totalPointsEarned)
                        //setUserPoints(response2.payload.content)

                        //setLoading(false)
                    })
                    .catch(err => {
                        //setLoading(false)
                        Swal({
                            title: err.response ? err.response.data.name : "Error",
                            text: err.response ? err.response.data.content : "Something went wrong",
                            icon: 'error'
                        })
                    })

                //setUserDetails(response.payload.content)
                // getProjectListing(1, 3)
                //getSurvey(1, true)
                // setLoading(false)
            })
            .catch(err => {
                //setLoading(false)
                Swal({
                    title: err.response ? err.response.data.name : "Error",
                    text: err.response ? err.response.data.content : "Something went wrong",
                    icon: 'error'
                })
            })
    }, []);

    const handleLinkClick = () => {

        let link = `https://app.consumerconnect.net/choose?code=${referCode}`
        const textArea = document.createElement('textarea');
        textArea.value = link;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        setCopied(true)

        Swal({
            title: 'Link Copied',
            icon: 'success'
        })


    }

    const toReachNextThreshold = () => {
        const currentPoints = points;
        const thresholds = [250, 500, 1000, 2500, 5000];

        let nextThreshold = null;

        for (let i = 0; i < thresholds.length; i++) {
            if (currentPoints < thresholds[i]) {
                nextThreshold = thresholds[i];
                break;
            }
        }


        if (!nextThreshold) {
            set_percentToNextThreshold({
                percentage: 100,
                next: thresholds[thresholds.length - 1]
            });
            return;
        }

        const percentage = (currentPoints / nextThreshold) * 100;

        set_percentToNextThreshold({
            percentage: Math.round(percentage, 100), // safety cap
            next: nextThreshold,
            remaining: nextThreshold - currentPoints
        });
    };
    useEffect(() => {
        toReachNextThreshold()
    }, [points])

    return (
        <TransitionGroup >

            <ResizeDetector
                handleWidth
                render={({ width }) => (

                    <LoadingOverlay tag="div" active={isLoading}
                        styles={{
                            overlay: (base) => ({
                                ...base,
                                background: "#fff",
                                opacity: 0.5,
                                position: 'fixed',
                                top: '20%'
                            }),
                        }}
                        spinner={
                            <Loader color="#6c757d" active type="ball-pulse" />
                        }>

                        <React.Fragment>










                            <div className="row" style={{ marginTop: window.innerWidth > 768 ? '50px' : '25px' }}>

                                <div className='col-12'>
                                    {/* connect points block */}
                                    <div className={styles.card_border}>



                                        <div className={styles.card_border_body + " pt-2 pb-3 px-0"}>
                                            <div style={{ height: '7rem' }}>
                                                <div className='d-flex' style={{ display: 'flex', alignItems: 'flex-end', alignContent: 'flex-end', marginRight: '20px' }}>
                                                    <p className={`${styles3.points} container pt-2`} style={{ margin: '0px' }}>{points}</p>
                                                    <p className={`${styles3.connect_rewards} pb-3`} style={{ minWidth: '60%', margin: '0px' }}>Connect Points</p>

                                                    <img src={pointsBadge} alt='image' className={`${styles3.badge}`}></img>


                                                </div>


                                                <div className='d-flex' >
                                                    <span> <Line className='container' percent={profileCompletion} strokeWidth={4} trailWidth={4} trailColor='#E5E5E5' strokeColor="#47B221" /></span>
                                                    <span style={{
                                                        color: '#ADA7A7',
                                                        fontSize: '15px', fontStyle: 'normal', fontWeight: '500'
                                                    }}>{profileCompletion ? profileCompletion : '0'}% profile</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* next threshold block */}
                                    <div className='pt-4'>
                                        <div className={styles.card_border}>



                                            <div className={styles.card_border_body + " px-3 px-0"}>
                                                <div style={{ height: '10rem' }}>

                                                    <div className='d-flex align-items-center' style={{ height: '100%' }}>

                                                        {/* <div style={{ height: '80%', aspectRatio: '1 / 1', position: 'relative' }}>

                                                            <Circle
                                                                percent={percentToNextThreshold.percentage}
                                                                strokeWidth={8}
                                                                trailWidth={8}
                                                                trailColor='#C1E4B5'
                                                                strokeColor="#47B221"
                                                            />

                                                           
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                    color: '#000',
                                                                    fontSize: '30px',
                                                                    fontWeight: '650',
                                                                    fontStyle: 'normal'
                                                                }}
                                                            >
                                                                {percentToNextThreshold?.percentage || '0'}%
                                                            </div>
                                                            

                                                        </div> */}
                                                        <div style={{ height: '100%', aspectRatio: '1 / 1', position: 'relative' }}>

                                                            <Circle
                                                                percent={percentToNextThreshold.percentage}
                                                                strokeWidth={8}
                                                                trailWidth={8}
                                                                trailColor='#E5E5E5'
                                                                strokeColor="#47B221"
                                                            />

                                                            {/* Centered Content */}
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                    textAlign: 'center',
                                                                    lineHeight: '1.1'
                                                                }}
                                                            >
                                                                {/* Percentage */}
                                                                <div
                                                                    style={{
                                                                        fontSize: '35px',
                                                                        fontWeight: '600',
                                                                        color: '#000'
                                                                    }}
                                                                >
                                                                    {percentToNextThreshold?.percentage || '0'}%
                                                                </div>

                                                                {/* "to reach" */}
                                                                <div
                                                                    style={{
                                                                        fontSize: '14px',
                                                                        fontWeight: '420',
                                                                        color: '#888',
                                                                        marginTop: '2px'
                                                                    }}
                                                                >
                                                                    completed to reach
                                                                </div>

                                                                {/* Target */}
                                                                <div
                                                                    style={{
                                                                        fontSize: '18px',
                                                                        fontWeight: '600',
                                                                        color: '#444'
                                                                    }}
                                                                >
                                                                    {percentToNextThreshold?.next}
                                                                </div>
                                                            </div>

                                                        </div>

                                                        {percentToNextThreshold?.remaining > 0 && <span className={window.innerWidth < 768 ? 'pl-4' : 'pl-4'} style={{
                                                            color: '#ADA7A7',
                                                            fontSize: '15px', fontStyle: 'normal', fontWeight: '500'
                                                        }}>Earn {percentToNextThreshold?.remaining || '0'} more points to reach next target of {percentToNextThreshold?.next || '0'} points</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   
                                    {/* bronze demo */}
                                    {profileCompletion >= 100 && <div className="pt-4">
                                        <div className={styles.card_border}>

                                            <div className={`${styles.card_border_body} pt-3 pb-0 px-3`}>

                                                {/* Badge + Rank */}
                                                <div className='row'>
                                                <div className="d-flex mb-2 col-12">
                                                    <img
                                                        src={bronze_badge}
                                                        alt="Bronze Badge"
                                                        className={styles3.rank_badges}
                                                    />
                                                    {/* Requirement */}
                                                <div className={styles3.rank_requirement}>
                                                   <img src={check_mark} className={`${styles3.tick_icon}`}></img> 100% profile completion
                                                   {/* <div className='col-12 text-center pt-3'>
                                                    <img src={streak} className={`${styles3.streak_icon}`}></img>
                                                </div> */}
                                                </div>
                                                </div>
                                                </div>

                                                <div className={styles3.rank_title}>
                                                    Rank <span className={styles3.rank_name}>Bronze</span>
                                                </div>

                                                

                                            </div>

                                            {/* Bottom Section (Rewards) */}
                                            <div className={`${styles3.rank_footer} text-center`}>
                                                No Incentives
                                            </div>

                                        </div>
                                    </div>}
                                    
                                    {/* silver demo */}
                                    {/* <div className="pt-4">
                                        <div className={styles.card_border}>

                                            <div className={`${styles.card_border_body} pt-3 pb-0 px-3`}>

                                               
                                                <div className='row'>
                                                <div className="d-flex mb-2 col-12">
                                                    <img
                                                        src={silver_badge}
                                                        alt="Silver Badge"
                                                        className={styles3.rank_badges}
                                                    />
                                                    
                                                <div className={styles3.rank_requirement}>
                                                   <img src={check_mark} className={`${styles3.tick_icon}`}></img> 3/3 quality check streak for 3 months
                                                    <div className='col-12 text-center pt-3'>
                                                    <img src={streak} className={`${styles3.streak_icon}`}></img>
                                                </div>
                                                </div>
                                                
                                                </div>
                                               
                                                </div>

                                                <div className={styles3.rank_title}>
                                                    Rank <span className={styles3.rank_name_silver}>Silver</span>
                                                </div>

                                                

                                            </div>

                                            
                                            <div className={`${styles3.rank_footer} text-center`}>
                                               <img src={tick_icon} alt='image' className={`${styles3.tick_icon}`}></img> Early access to surveys
                                            </div>

                                        </div>
                                    </div> */}

                                     {/*gold demo */}
                                    {/* <div className="pt-4">
                                        <div className={styles.card_border}>

                                            <div className={`${styles.card_border_body} pt-3 pb-0 px-3`}>

                                                
                                                <div className='row'>
                                                <div className="d-flex mb-2 col-12">
                                                    <img
                                                        src={gold_badge}
                                                        alt="Gold Badge"
                                                        className={styles3.rank_badges}
                                                    />
                                                    
                                                <div className={styles3.rank_requirement}>
                                                   <img src={check_mark} className={`${styles3.tick_icon}`}></img> 3/3 quality check streak for 6 months
                                                   <div className='col-12 text-center pt-3'>
                                                    <img src={streak} className={`${styles3.streak_icon}`}></img>
                                                </div>
                                                </div>
                                                </div>
                                                </div>

                                                <div className={styles3.rank_title}>
                                                    Rank <span className={styles3.rank_name_gold}>Gold</span>
                                                </div>

                                                

                                            </div>

                                            
                                            <div className={`${styles3.rank_footer} text-center`}>
                                               <img src={tick_icon} alt='image' className={`${styles3.tick_icon}`}></img> Early access & priority payouts
                                            </div>

                                        </div>
                                    </div> */}


                                    {/* refer banner */}
                                    <div className='pt-4'>
                                        <div className={styles3.card_border_borderless} style={{ backgroundColor: '#E6D2FF' }}>




                                            <div className={styles.card_border_body + " pt-2 pb-3 px-0"} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={handleLinkClick} >
                                                <div style={{ height: '6rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <p className={`${styles3.refer_block_text} container`} style={{ flex: '50%' }}>Earn points by referring people around.</p>
                                                    <img src={referImage} alt='image' style={{ flex: '50%', maxHeight: '100%', maxWidth: '25%' }}></img>
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </div>



                            </div>












                        </React.Fragment>


                    </LoadingOverlay>

                )}

            />
        </TransitionGroup>
    )

}

export default ConnectPoints;